import React from 'react';

const AquariusIcon = ({ width = '80', height = '80', color = '#f1c40f' }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 40C30 30 40 40 50 30C60 40 70 30 80 40" stroke={color} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20 70C30 60 40 70 50 60C60 70 70 60 80 70" stroke={color} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default AquariusIcon;
